import { Swiper, Navigation, Mousewheel } from "swiper";

import ProductCardRenderer from "../common/product-card-renderer";
const productCardRenderer = ProductCardRenderer();

import Wishlist from "../common/wishlist";
const wishlist = Wishlist();

const renderProducts = (section) => {
  const ids = section.productIds.map((id) => "gid://shopify/Product/" + id);
  window.ShopifyClient.fetchProducts(ids)
    .then((products) => {
      products.forEach((product) => {
        wishlist.addShopifyProductToViewProducts(product);
      });
      const items = products.map((product) => {
        const item = productCardRenderer.renderShopifyProduct(product);
        return `<div class="swiper-slide">${item}</div>`;
      });
      const sectionElement = document.querySelector(`#shopify-section-${section.id}`);
      const swiperElement = sectionElement.querySelector(".swiper");
      const wrapperElement = swiperElement.querySelector(".swiper-wrapper");
      wrapperElement.innerHTML = items.join("");

      productCardRenderer.addWishlistButtonListener(wrapperElement);
      wishlist.updateButtons();

      section.lastSlideWidth = 100;

      section.swiper = new Swiper(swiperElement, {
        modules: [Navigation, Mousewheel],
        centerInsufficientSlides: true,
        speed: 300,
        slidesPerView: 2.5,
        slidesPerGroup: 1,
        spaceBetween: 8,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          sensitivity: 0.1,
          thresholdDelta: 10,
        },
        navigation: {
          nextEl: sectionElement.querySelector(".fs-swiper-navigation-next"),
          prevEl: sectionElement.querySelector(".fs-swiper-navigation-prev"),
        },
        breakpoints: {
          992: {
            speed: 900,
            slidesPerView: 4.5,
            slidesPerGroup: 4,
            spaceBetween: 12,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
          },
          1298: {
            speed: 900,
            slidesPerView: 5.4,
            slidesPerGroup: 5,
            spaceBetween: 12,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
          },
        },
      });
    })
    .catch((err) => {
      /* console.error(err) */
      const sectionElement = document.querySelector(`#shopify-section-${section.id}`);
      sectionElement.classList.add("hidden");
    });
};

const mediaSliderProductsShopifyMain = () => {
  if (!window.fstore.sections) {
    return;
  }
  const sectionTypes = [
    "media-slider-products-collection",
    "media-slider-products-selected",
    "media-slider-products-brand",
  ];
  window.fstore.sections
    .filter((section) => sectionTypes.includes(section.sectionType))
    .forEach((section) => {
      renderProducts(section);
    });
};

addEventListener("DOMContentLoaded", () => {
  mediaSliderProductsShopifyMain();
});
